import { HealthProgramStatisticsResponse, ScreeningInsightsResponse } from '@estercare/ester-shared'
import { appConfig } from '../../../../config'
import { env } from '../../../../utils/environments/environmentVariables'
import { TestimonialsResponse } from './types'

const IS_PROD = env.isProd('VITE_NODE_ENV')
// Non-production environments always use mocked statistics, so every section renders with data.

export const getHealthProgramStatistics = async ({
  accessToken,
}: {
  accessToken: string
}): Promise<HealthProgramStatisticsResponse> => {
  if (!IS_PROD) {
    const { healthProgramMock } = await import('./mocks/healthProgram')
    return healthProgramMock
  }

  const res = await fetch(`${appConfig.serverRootUrl}/api/private/analytics/healthProgram`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch health programme statistics: ${res.status}`)
  }

  return res.json()
}

export const getScreeningInsights = async ({
  accessToken,
}: {
  accessToken: string
}): Promise<ScreeningInsightsResponse> => {
  if (!IS_PROD) {
    const { screeningInsightsMock } = await import('./mocks/screeningInsights')
    return screeningInsightsMock
  }

  const res = await fetch(`${appConfig.serverRootUrl}/api/private/analytics/screeningInsights`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch screening insights: ${res.status}`)
  }

  return res.json()
}

export const getTestimonials = async ({ accessToken }: { accessToken: string }): Promise<TestimonialsResponse> => {
  if (!IS_PROD) {
    const { testimonialsMock } = await import('./mocks/testimonials')
    return testimonialsMock
  }

  const res = await fetch(`${appConfig.serverRootUrl}/api/private/analytics/testimonials`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch testimonials: ${res.status}`)
  }

  return res.json()
}
